import { TagsComponent } from '@app/components/Modals/BotDetailsModal/components/TagsComponent';

import { DeadlineFields } from './DeadlineFields';
import { IncomingMessageTriggerFields } from './IncomingMessageTriggerFields';
import { InstagramButtons } from './InstagramButtons';
import { KeywordMessageRobotFields } from './KeywordMessageRobotFields';
import { SocialChannelFields } from './SocialChannelFields';

export {
  TagsComponent,
  DeadlineFields,
  IncomingMessageTriggerFields,
  InstagramButtons,
  KeywordMessageRobotFields,
  SocialChannelFields,
};
